<template>
  <div>
    <Header />
    <div class="latis">
      <div class="container">
        <Location />
        <Menu v-if="setOutletID != null" />
        <Cart />
        <div class="open_cart_img cartfloat product-cart-open">
          <div class="cart-icon">
            <i class="fa fa-shopping-cart fa-2x"></i>
            <span class="badge">{{ cartItemCount }}</span>
          </div>
          <button class="checkout-button-cart" @click="openCart">
            Checkout
          </button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./Header";
import Location from "./Location";
//import CategoryMain from "./CategoryMain"
import Cart from "./Cart";
import Menu from "./Menu";
import Footer from "./Footer";
import { mapGetters } from "vuex";
//import offline from 'v-offline';
export default {
  name: "HomeComponent",
  components: {
    Header,
    Location,
    //CategoryMain,
    Menu,
    Cart,
    Footer,
    // offline
  },
  computed: {
    ...mapGetters(["setOutletID"]),
    ...mapGetters(["cartItemCount"]),
  },
  mixins: [Cart],
  data() {
    return {
      net_status: "",
      menuload: null,
    };
  },
  methods: {
    handleConnectivityChange(status) {
      //console.log("Status is "+status);
      this.net_status = status;
    },
    openCart() {
      this.open_well_cart();
    },
  },
  mounted() {
    this.menuload = this.setOutletID;
  },
};
</script>